var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input-component',{attrs:{"placeholder":"Enter your response"},model:{value:(_vm.responseValue),callback:function ($$v) {_vm.responseValue=$$v},expression:"responseValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }